import { TolgeeProvider } from "@tolgee/react";
// Import required Moment.js locales
// @ts-ignore // FIXME
import "moment/dist/locale/de";
// @ts-ignore // FIXME
import "moment/dist/locale/en-gb";
// @ts-ignore // FIXME
import "moment/dist/locale/fr";
// @ts-ignore // FIXME
import "moment/dist/locale/nl";
// @ts-ignore // FIXME
import "moment/dist/locale/pl";
// @ts-ignore // FIXME
import "moment/dist/locale/ru";
import React from "react";
import { tolgee } from "./tolgee.js";

export function TranslationsProvider({ children }: React.PropsWithChildren) {
  return (
    <TolgeeProvider tolgee={tolgee} options={{ useSuspense: false }}>
      {children}
    </TolgeeProvider>
  );
}
